import { createContext, useState } from "react";

export const AppGlobalContext = createContext({});

const AppContext = ({ children }) => {
  const [appState, setAppState] = useState({
    isAuthUser: false,
    loggedInUserRole: null,
    responsibilities: null,
    authUserDetails: {},
  });

  const handleStateUpdate = (newData) => {
    var collectAllState = {
      ...appState,
      ...newData,
    };

    setAppState(collectAllState);
  };

  const data = {
    ...appState,
    SetAppState: (nData) => handleStateUpdate(nData),
  };

  return (
    <AppGlobalContext.Provider value={data}>
      {children}
    </AppGlobalContext.Provider>
  );
};

export default AppContext;
